import { render } from "./ReportPage.vue?vue&type=template&id=4b98acf6&scoped=true"
import script from "./ReportPage.vue?vue&type=script&lang=js"
export * from "./ReportPage.vue?vue&type=script&lang=js"

import "./ReportPage.vue?vue&type=style&index=0&id=4b98acf6&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b98acf6"]])

export default __exports__